import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { UserCog, LogOut } from 'lucide-react';

/**
 * Banner globale mostrato quando l'admin sta operando "come" un altro utente
 * (impersonation). Persistente in alto, sempre visibile finché non si torna admin.
 */
export function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useAuth();
  const [leaving, setLeaving] = useState(false);
  if (!isImpersonating || !user) return null;

  const who = user.company_name || user.name || user.email || 'utente';
  const role = user.tenant_type || user.role || '';
  const admin = user.impersonator || {};

  const onExit = async () => {
    setLeaving(true);
    try { await stopImpersonation(); } catch { setLeaving(false); }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[300] flex items-center gap-3 border-b border-[hsl(38_92%_40%)] bg-[hsl(38_92%_50%/0.16)] px-4 py-2 backdrop-blur-md"
      role="status"
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[hsl(38_92%_45%)] text-[hsl(38_100%_12%)]">
        <UserCog className="h-4 w-4" />
      </span>
      <p className="min-w-0 flex-1 truncate text-sm text-[hsl(38_100%_18%)] dark:text-[hsl(38_92%_82%)]">
        Stai operando come{' '}
        <strong className="font-semibold" data-testid="impersonation-target">{who}</strong>
        {role ? <span className="opacity-80"> · {role}</span> : null}
        {admin.email ? (
          <span className="ml-2 hidden text-xs opacity-70 sm:inline">
            (admin: {admin.name || admin.email})
          </span>
        ) : null}
      </p>
      <Button
        size="sm"
        variant="outline"
        onClick={onExit}
        disabled={leaving}
        data-testid="impersonation-exit-btn"
        className="shrink-0 gap-1.5 border-[hsl(38_92%_40%)] bg-background/70 hover:bg-background"
      >
        <LogOut className="h-3.5 w-3.5" />
        {leaving ? 'Esco…' : 'Torna ad Admin'}
      </Button>
    </div>
  );
}

export default ImpersonationBanner;
